import * as React from "react";

import { getSupportTopOffendersTableColumns } from "src/core/shared/components/tables/supportTopOffendersTableColumns";
import { PaginatedParams } from "src/library/utils/apiTypes";
import {
  SupportTopOffendersData,
  useWidgetDataApi
} from "src/core/dashboard/api/widget-data.api";
import useWidgetContainerSize from "src/core/dashboard/hooks/useWidgetContainerSize";

import Table from "../table/Table";
import { WidgetInnerHeader } from "../WidgetInnerHeader";
import { WidgetProps } from "../utils";

export const SupportTopOffendersWidget: React.FC<WidgetProps> = ({ filters, widgetTypeId }) => {
  const [ getSupportTopOffendersResp, getSupportTopOffendersReq ] = useWidgetDataApi("GET_SUPPORT_TOP_OFFENDERS");
  const wrapperRef = React.createRef<HTMLDivElement>();
  const { size } = useWidgetContainerSize(wrapperRef);

  const onFetchData = React.useCallback((params: {pagination: PaginatedParams<SupportTopOffendersData>}) => {
    getSupportTopOffendersReq({
      widgetTypeId,
      filters,
      options: { pagination: params.pagination }
    });
  }, [
    filters,
    getSupportTopOffendersReq,
    widgetTypeId
  ]);

  const defaultPagination: PaginatedParams<SupportTopOffendersData> = {
    offset: 0,
    limit: 10,
    page: 0,
    sort: [ [ "totalResolved", "DESC" ] ]
  };

  const data = React.useMemo(() => getSupportTopOffendersResp.data?.result?.result, [ getSupportTopOffendersResp.data?.result?.result ]);
  const columns = React.useMemo(getSupportTopOffendersTableColumns, []);

  return (
    <div ref={wrapperRef}>
      <WidgetInnerHeader title="Support Top Offenders" />

      <Table
        tableOf="SupportOffenders"
        hideHeader
        className={size}
        data={data || []}
        columns={columns}
        onFetchData={onFetchData}
        loading={getSupportTopOffendersResp.pending}
        defaultPagination={defaultPagination}
        pageCount={getSupportTopOffendersResp.data?.result?.pages}
        rowCount={getSupportTopOffendersResp.data?.result?.count}
      />
    </div>
  );
};
